import React, { useMemo } from 'react';
import NoDataComponent from '../../../dashboard_gen2/no_data_component.jsx';
import { useSelector } from 'react-redux';
import { useImageSrc } from '../../hooks/useImageSrc.js';
import styles from './ImageWidget.module.scss';

const isLink = (link) => {
    if (!link || link.length === 0 || !/^(https?:)?\/\//i.test(link)){
        return false;
    }
    try {
        return new URL(link, window.location.href);
    } catch {
        return false;
    }
}

function ImageWidget({ widgetId }) {
    const image_src = useSelector(state => state.dashboard.widgets[widgetId].settings?.image_src);
    const image_size = useSelector(state => state.dashboard.widgets[widgetId].settings?.image_size);
    const attachment = useSelector(state => state.dashboard.widgets[widgetId].settings?.attachment);
    const link = useSelector(state => state.dashboard.widgets[widgetId].settings?.link);
    const src = useImageSrc({path: image_src || attachment?.path});
    const isGivenLink = useMemo(() => isLink(link), [link]);

    const clickLink = () => {
        if (isGivenLink){
            const url = new URL(link, window.location.href);
            if (url.origin === window.location.origin){
                window.location.href = url;
            } else {
                window.open(url, '_blank');
            }
        }
    }

    return (
        src ? <div
            style={{
                width: '100%',
                height: '100%', 
                display: 'block', 
                backgroundImage: `url(${src})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: image_size || 'cover',
                backgroundPosition: 'center',
            }}
            className={isGivenLink ? styles['link-style'] : ''}
            onClick={clickLink}
        /> : <NoDataComponent className='image-widget' text={I18n.t('image_widget_no_data_description')} />
    )
}

export default ImageWidget;
